<div class="level-progress">
  <div class="level-progress__block" *ngFor="let level of levelsProgressData">
    <div class="level-progress__block__name">
      <span>{{ level?.levelName }}</span>
    </div>
    <mat-progress-bar mode="determinate" [value]="level?.progressPercentage"></mat-progress-bar>
  </div>
</div>
